
import {Component, Vue} from "vue-property-decorator";
import StudyInstituteCreateDialog from "@/components/institute/StudyInstituteCreateDialog.vue";
import StudyInstituteEditDialog from "@/components/institute/StudyInstituteEditDialog.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {ntdInstitutesModule} from "@/store";
import NtdInstituteTable from "@/components/ntd/NtdInstituteTable.vue";

@Component({
  components: {
    NtdInstituteTable,
    StudyInstituteCreateDialog,
    StudyInstituteEditDialog,
    ConfirmDialog
  },
})
export default class NtdInstitutes extends Vue {
  async mounted() {
    await ntdInstitutesModule.loadAll();
  }
}
